var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.70097 14.8902L0.109847 13.2991C-0.0367783 13.1525 -0.0367783 12.9151 0.109847 12.7688L4.13322 8.74547C4.27985 8.59884 4.51722 8.59884 4.66347 8.74547L6.2546 10.3366C6.40122 10.4832 6.40122 10.7206 6.2546 10.8668L2.23122 14.8902C2.0846 15.0368 1.84722 15.0368 1.70097 14.8902Z",
    fill: "#45A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2326 9.35702L0.109847 2.23427C-0.0367783 2.08765 -0.0367783 1.85027 0.109847 1.70402L1.70097 0.112898C1.8476 -0.0337266 2.08497 -0.0337266 2.23122 0.112898L9.35397 7.23565C9.5006 7.38227 9.5006 7.61965 9.35397 7.7659L7.76285 9.35702C7.61622 9.50327 7.37885 9.50327 7.2326 9.35702Z",
    fill: "#4C68A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.4635,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightList);
export default __webpack_public_path__ + "static/media/arrow-right-list.65dab6ada8c2e23543feaa2b7497475d.svg";
export { ForwardRef as ReactComponent };